import { useRecoilState } from 'recoil';
import { ReactComponent as Spinner } from '../assets/Spinner.svg';
import { loadingState } from '../states/loadingState';

const Loading = () => {
  const [isLoading] = useRecoilState(loadingState);

  if (isLoading)
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: 10000,
        }}
      >
        <Spinner />
      </div>
    );
};

export default Loading;
